"use strict";

(function ($) {
  $.fn.openModal = function () {
    return $(this).each(function () {
      var $that = $(this),
          $target = $($that.data('target'));

      if ($that.hasClass('modal-lawyer')) {
        var str = $that.data('contact-infos').replace(/'/g, '"');
        var json = $.parseJSON(str),
            $url = json.url,
            $phone = json.phone_number,
            $share_phone = json.share_phone,
            $share_mail = json.share_mail,
            $direct_phone = json.direct_phone_number,
            $share_direct_phone = json.share_direct_phone,
            $mobile_phone = json.mobile_phone_number,
            $share_mobile_phone = json.share_mobile_phone,
            $image = $that.data('image'),
            $phones = [];

        if ($phone && $phone != "undefined" && $share_phone == 'True') {
          $phones.push($phone);
        }

        if ($direct_phone && $direct_phone != "undefined" && $share_direct_phone == 'True') {
          $phones.push($direct_phone);
        }

        if ($mobile_phone && $mobile_phone != "undefined" && $share_mobile_phone == 'True') {
          $phones.push($mobile_phone);
        }

        var $fname = json.first_name,
            $lname = json.last_name;
      }

      if ($that.hasClass('modal-firm')) {
        var str = $that.data('contact-infos').replace(/'/g, '"'),
            json = $.parseJSON(str),
            $url = json.url,
            $phone = json.phone_number,
            $direct_phone = json.direct_phone_number,
            $share_direct_phone = json.share_direct_phone,
            $share_mail = json.share_mail,
            $mobile_phone = json.mobile_phone_number,
            $share_mobile_phone = json.share_mobile_phone,
            $image = $that.data('image'),
            $name = json.name,
            $phones = [];

        if ($phone && $phone != "undefined") {
          $phones.push($phone);
        }

        if ($direct_phone && $direct_phone != "undefined") {
          $phones.push($direct_phone);
        }

        if ($mobile_phone && $mobile_phone != "undefined") {
          $phones.push($mobile_phone);
        }
      }

      $that.on('click', function (e) {
        e.stopPropagation(); // console.log($target);

        if ($('.js-modal-container.is-open').not($target).length) {
          $('.js-modal-container.is-open').not($target).removeClass('is-open');
          setTimeout(function () {
            $target.addClass('is-open');
          }, 100);
        } else {
          if ($that.hasClass('modal-lawyer')) {
            getLawyer($target, $fname, $lname, $url, $phones, $image, $share_phone, $share_mail);
          } else if ($that.hasClass('modal-firm')) {
            getFirm($target, $name, $url, $phones, $image, $share_phone, $share_mail);
          } else {
            setTimeout(function () {
              $target.addClass('is-open');
            }, 100);
          }
        } // fixBody();

      });

      function getLawyer(target, fname, lname, lawyerUrl, lawyerPhones, image, share_phone, share_mail) {
        var name = target.find('.js-name'),
            url = target.find('.js-url'),
            phone = target.find('.js-show-tel'),
            imageLawyer = target.find('.js-image');

        if (!lawyerPhones.length) {
          phone.addClass('hide');
        } else {
          phone.removeClass('hide');
        }

        if (share_mail != 'True') {
          url.addClass('hide');
        } else {
          url.removeClass('hide');
        }

        if (image) {
          imageLawyer.css({
            'background-image': 'url(' + image + ')'
          });
        } else {
          imageLawyer.css({
            'background-image': 'url(../static/svg/gesica-logo-no-image.svg)',
            'background-size': '30px'
          });
        }

        name.text(fname + ' ' + lname);
        url.attr('href', lawyerUrl);
        phone.attr('data-numbers', lawyerPhones);
        target.addClass('is-open');
        initTel(target);
      }

      function getFirm(target, nameFirm, lawyerUrl, firmPhones, image, share_phone, share_mail) {
        var name = target.find('.js-name'),
            url = target.find('.js-url'),
            phone = target.find('.js-show-tel'),
            imageFirm = target.find('.js-image');

        if (!firmPhones.length) {
          phone.addClass('hide');
        } else {
          phone.removeClass('hide');
        }
        /*if( share_mail != 'True' ) {
            url.addClass('hide');
        }else{
            url.removeClass('hide');
        }*/


        if (image) {
          imageFirm.css({
            'background-image': 'url(' + image + ')'
          });
        } else {
          imageFirm.css({
            'background-image': 'url(../static/svg/gesica-logo-no-image.svg)',
            'background-size': '30px'
          });
        }

        name.text(unescape(nameFirm));
        url.attr('href', lawyerUrl);
        phone.attr('data-numbers', firmPhones);
        target.addClass('is-open');
        initTel(target);
      }
    });
  };
})(jQuery);

(function ($) {
  $.fn.closeModal = function () {
    return $(this).each(function () {
      var $that = $(this);
      $that.on('click', function () {
        if ($('.js-modal-container.is-open').length) {
          var cookieName = 'modal-' + $('.js-modal-container.is-open .js-modal').data('id');
          Cookies.set(cookieName, '1', {
            expires: 365
          });
          $('.js-modal-container.is-open').removeClass('is-open'); // unfixBody();

          setTimeout(function () {
            clearTel();
          }, 100);
        }
      });
    });
  };
})(jQuery);

$(function () {
  // if ($('.js-modal').length) {
  //     $('.js-modal').each(function(){
  //         if (Cookies.get('modal-' + $(this).data('id')) != 1) {
  //             $(this).parent().addClass('is-open');
  // fixBody();
  //         }
  //     });
  // }
  if ($('.js-open-modal').length) {
    $('.js-open-modal').openModal();
  }

  if ($('.js-close-modal').length) {
    $('.js-close-modal').closeModal();
  }

  $body.on('click', function () {
    if ($('.js-modal-container.is-open').length) {
      var cookieName = 'modal-' + $('.js-modal-container.is-open .js-modal').data('id');
      Cookies.set(cookieName, '1', {
        expires: 365
      });
      $('.js-modal-container.is-open').removeClass('is-open');
      setTimeout(function () {
        clearTel();
      }, 100); // unfixBody();
    }

    if ($('.js-lightbox-container.is-open').length) {
      $('.js-lightbox-container').removeClass('is-open');
      setTimeout(function () {
        clearTel();
      }, 100); // unfixBody();
    }
  });
  $(document).on('keydown', function (e) {
    if ($('.js-lightbox-container.is-open').length) {
      if (e.keyCode == 37) {
        prevLightboxItem();
      } else if (e.keyCode == 39) {
        nextLightboxItem();
      } else if (e.keyCode == 27) {
        // unfixBody();
        $('.js-lightbox-container').removeClass('is-open');
      }
    }
  });
  $('.js-modal, .js-lightbox').on('click', function (e) {
    e.stopPropagation();
  });
  $('.js-item-lightbox').on('click', function (e) {
    e.stopPropagation(); // fixBody();

    $('.js-lightbox-container').addClass('is-open');
    lightboxImgs = $(this).parents('.js-items-lightbox').data('images');
    lightboxIndex = $(this).data('index');
    var src = lightboxImgs[lightboxIndex];
    loadLightboxImg(src);
  });
  $('.js-close-lightbox').on('click', function (e) {
    // unfixBody();
    $('.js-lightbox-container').removeClass('is-open');
  });
  $('.js-next-lightbox').on('click', function (e) {
    e.stopPropagation();
    nextLightboxItem();
  });
  $('.js-prev-lightbox').on('click', function (e) {
    e.stopPropagation();
    prevLightboxItem();
  });
});

function nextLightboxItem() {
  if (lightboxIndex < lightboxImgs.length - 1) {
    lightboxIndex++;
  } else {
    lightboxIndex = 0;
  }

  var src = lightboxImgs[lightboxIndex];
  loadLightboxImg(src);
}

function prevLightboxItem() {
  if (lightboxIndex > 0) {
    lightboxIndex--;
  } else {
    lightboxIndex = lightboxImgs.length - 1;
  }

  var src = lightboxImgs[lightboxIndex];
  loadLightboxImg(src);
}

function loadLightboxImg(src) {
  var img = new Image();
  img.src = src;
  $('.js-lightbox').css('background-image', '').addClass('loading');

  if (src.length) {
    $(img).on('load', function () {
      $('.js-lightbox').removeClass('loading');
      $('.js-lightbox').css('background-image', 'url(' + src + ')');
    });
  }
}